import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';
import { push } from 'connected-react-router';

import { LOGOUT_USER } from '../types';
import { logoutUserPending, logoutUserFulfilled, logoutUserRejected } from '../actions/logoutUser';
import { sendApiRequest, notifyError } from '../actions';
import routesConfig from '../routes/routes-config';
import generateError from '../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'home/logout',
  onSuccess: [
    logoutUserFulfilled,
    () => push(routesConfig.homePage.path),
  ],
  onError: [
    logoutUserRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const getWatchListsEpic$ = action$ => action$.pipe(
  ofType(LOGOUT_USER.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => merge(
    of(logoutUserPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default getWatchListsEpic$;


// WEBPACK FOOTER //
// ./src/epics/logoutUser.js